import type { ErrorInfo } from 'react';
import type React from 'react';
import { Component } from 'react';
import Logger from '../utils/Logger';

interface GenericErrorBoundaryProps {
  name: string;
  children: React.ReactNode;
}

interface GenericErrorBoundaryState {
  hasError: boolean;
}

class GenericErrorBoundary extends Component<
  GenericErrorBoundaryProps,
  GenericErrorBoundaryState
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: GenericErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Logger.fatal(error, errorInfo, {
      tags: { errorBoundary: this.props.name },
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default GenericErrorBoundary;
